import type { Component } from 'solid-js'
import type { IconProps } from './icon'

const Video: Component<IconProps> = (props) => {
  const size = () => props.size ?? 12

  return (
    <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" class={`size-${size()} rounded-lg`}>
      <rect width="48" height="48" fill="#F3F4F6" rx="8" />
      <path
        d="M24.75 16.5C26.4069 16.5 27.75 17.8431 27.75 19.5V28.5C27.75 30.1569 26.4069 31.5 24.75 31.5H16.5C14.8431 31.5 13.5 30.1569 13.5 28.5V19.5C13.5 17.8431 14.8431 16.5 16.5 16.5H24.75Z"
        fill="#99A1AF"
      />
      <path
        d="M31.9395 17.25C32.8844 16.3051 34.4999 16.9743 34.5 18.3105V29.6895C34.4999 31.0257 32.8844 31.6948 31.9395 30.75L29.25 28.0605V19.9395L31.9395 17.25Z"
        fill="#99A1AF"
      />
    </svg>
  )
}

export default Video
